import React from 'react'
import { useNotifications } from 'app/hooks/DynamoDBhooks/useNotifications'
import { examStatusAlerts, linkMessageAlert } from './headChatBotAlert'
import { TypeChatBotProps } from './types'


type Props = {}

const useChatBotAlert = (props: TypeChatBotProps) => {
  const { status, examId, useStatic, theme } = props
  const [expand, setExpand] = React.useState(false)
  const statusMessage = examStatusAlerts[status as keyof object]
  const link: { href: string; label: string } | null = status && linkMessageAlert.hasOwnProperty(status) ? linkMessageAlert[status as keyof typeof linkMessageAlert] : null;

  // Use the existing hook
  let data, loading, error
  if (!useStatic) {
    const notification = useNotifications({});
    data = notification.data
    loading = notification.loading
    error = notification.error
  }

  // Filter notifications for this exam
  const examMessages = !useStatic && React.useMemo(() => {
    if (!data || !examId) return [];
    return data
      .filter(notification => notification.examId === examId)
      .sort((a, b) => b.timestamp - a.timestamp); // Ensure newest first
  }, [data, examId]);

  return {
    expand,
    setExpand,
    statusMessage,
    link,
    data,
    loading,
    error,
    examMessages,
  }
}

export default useChatBotAlert